import React from 'react'

const Banner = () => {
  return (
    <header class="header">
    <div class="container flex">
      <div class="text">
      <h1 class="mb">
Wortheweight
        </h1>
    

      
      </div>

      {/* <div class="visual">
        <img
          src="https://i.imgur.com/deSycGl.png"
          alt=""
        />
      </div> */}
    </div>
  </header>

  )
}

export default Banner